/**
 * Site Settings Configuration
 *
 * This file contains global configuration values for the Loop  landing page.
 * Centralize all site-wide constants and settings here for easy maintenance.
 */

export const siteSettings = {
  // Site Information
  siteName: 'Loop',
  siteDescription: 'Innovative solutions for modern restaurants',
  siteUrl: 'https://tryloop.com',
  // Contact Information
  contactEmail: 'support@tryloop.com',
  // Social Media
  socialMedia: {
    twitter: 'https://twitter.com/tryloop',
    facebook: 'https://facebook.com/tryloop',
    instagram: 'https://instagram.com/tryloop',
    linkedin: 'https://linkedin.com/company/loopkitchen',
  },

  // API Endpoints
  apiEndpoints: {
    base: 'https://api.tryloop.com',
    contact: '/contact',
    schedule: '/schedule',
    menu: '/menu',
  },

  // Booking
  booking: {
    calendlyUrl: 'https://calendly.com/salesops-tryloop/loop-discussion',
  },

  // Feature Flags
  features: {
    enableBooking: true,
    enableChat: true,
    enableReviews: true,
    enableNewsletterSignup: true,
  },



  // SEO Settings
  seo: {
    defaultTitle: 'Loop - Innovative Restaurant Solutions',
    titleTemplate: '%s | Loop ',
    defaultDescription: 'Loop provides innovative solutions for modern restaurants to optimize operations and enhance customer experience.',
    defaultKeywords: 'restaurant, technology, food service, automation',
    ogImage: '/images/og-image.jpg',
  }
};

// Export individual settings for convenience
export const { siteName, siteUrl, apiEndpoints, booking, features } = siteSettings;

// Default export for easier importing
export default siteSettings;
